module.exports = __webpack_public_path__ + "img/noticia1.c857be45.png";